const generateHouseSitterUrl = () => {
    return `https://trustedhousesitters.pxf.io/c/5194722/1851868/18144`
}

export default generateHouseSitterUrl
